// extracted by mini-css-extract-plugin
export default {"staticPinCodeContainer":"pin-code-container__static-pin-code-container__mcs7I"};